/**
 * Performance monitoring utility for beacon positioning
 */

// Performance monitoring state
let performanceMetrics = {
  positioningAttempts: 0,
  successfulPositions: 0,
  averagePositioningTime: 0,
  totalPositioningTime: 0,
  cacheHits: 0,
  cacheMisses: 0
};

/**
 * Start performance timing
 * @returns {number} - Start time
 */
export const startPerformanceTimer = () => {
  return performance.now();
};

/**
 * End performance timing and record metrics
 * @param {number} startTime - Start time from startPerformanceTimer
 * @param {boolean} success - Whether positioning was successful
 */
export const endPerformanceTimer = (startTime, success) => {
  const endTime = performance.now();
  const duration = endTime - startTime;
  
  performanceMetrics.positioningAttempts++;
  if (success) {
    performanceMetrics.successfulPositions++;
  }
  performanceMetrics.totalPositioningTime += duration;
  performanceMetrics.averagePositioningTime = 
    performanceMetrics.totalPositioningTime / performanceMetrics.positioningAttempts;
};

/**
 * Record cache hit
 */
export const recordCacheHit = () => {
  performanceMetrics.cacheHits++;
};

/**
 * Record cache miss
 */
export const recordCacheMiss = () => {
  performanceMetrics.cacheMisses++;
};

/**
 * Get performance metrics
 * @returns {Object} - Performance metrics
 */
export const getPerformanceMetrics = () => {
  return { ...performanceMetrics };
};

/**
 * Reset performance metrics
 */
export const resetPerformanceMetrics = () => {
  performanceMetrics = {
    positioningAttempts: 0,
    successfulPositions: 0,
    averagePositioningTime: 0,
    totalPositioningTime: 0,
    cacheHits: 0,
    cacheMisses: 0
  };
};

/**
 * Log performance metrics to console
 */
export const logPerformanceMetrics = () => {
  console.log('Beacon Performance Metrics:', {
    ...performanceMetrics,
    successRate: performanceMetrics.positioningAttempts > 0 ? 
      (performanceMetrics.successfulPositions / performanceMetrics.positioningAttempts * 100).toFixed(2) + '%' : '0%',
    cacheHitRate: (performanceMetrics.cacheHits + performanceMetrics.cacheMisses) > 0 ?
      (performanceMetrics.cacheHits / (performanceMetrics.cacheHits + performanceMetrics.cacheMisses) * 100).toFixed(2) + '%' : '0%'
  });
};

export default {
  startPerformanceTimer,
  endPerformanceTimer,
  recordCacheHit,
  recordCacheMiss,
  getPerformanceMetrics,
  resetPerformanceMetrics,
  logPerformanceMetrics
};